import { useMemo } from "react";

import { isNil } from "lodash";

import { useSwrFetch } from "./useSwrFetch";

import type { CompanyProfile } from "types/company";

export function useCompanyProfile(companyId: number | null) {
  const url = useMemo(
    () =>
      !isNil(companyId) ? `/companies/${companyId}/carrier-profile` : null,
    [companyId],
  );

  const {
    data: companyProfile,
    loading,
    error,
    refetch: refetchProfile,
  } = useSwrFetch<CompanyProfile>({
    url,
    errorMessage: "Failed to fetch company profile information",
  });

  return {
    companyProfile: companyProfile ?? null,
    loading,
    error,
    refetchProfile,
  };
}
